<template>
  <v-app>
    <!-- Add the top bar and the navigation side menu here -->
    <AccesslinkTopBar @toggleSidemenu="toggleSidemenu()" />

    <v-main>
      <v-container fluid id="accesslink-main-container" class="" style="">
        <v-row v-if="getNotes && getAccesslinkPods && getAccesslinkPods.length > 1" data-cy="accessLink-view-notes">
          <v-col offset="0" cols="12"  offset-sm="1" sm="10"  offset-md="2" md="8">
            <div v-html="getNotes" class="accesslink-notes markdown-preview" style="" role="note" />
          </v-col>
        </v-row>

        <v-row class="mt-4 mb-4">
          <v-col offset="10" sm="12" md="8" cols="2" offset-md="2" offset-sm="0" class="d-flex flex-column align-end">
            <v-tooltip
              location="bottom"
              :aria-label="listViewType === 'list' ? $t('menus.topBars.viewAsGrid') : $t('menus.topBars.viewAsList')"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  @click="toggleListViewType"
                  :elevation="0"
                  :aria-label="listViewType === 'list' ? $t('menus.topBars.viewAsGrid') : $t('menus.topBars.viewAsList')"
                  :aria-pressed="listViewType === 'grid'"
                  :icon="listViewType === 'list' ? 'mdi-view-module' : 'mdi-view-list'"
                   style="border-radius: 10px;"
                />
              </template>

              <span v-if="listViewType === 'list'">{{ $t('menus.topBars.viewAsGrid') }}</span>
              <span v-else-if="listViewType === 'grid'">{{ $t('menus.topBars.viewAsList') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <AccesslinkListView v-if="listViewType === 'list'" :code="code" :pods="getAccesslinkPods" :nodes="getAccesslinkNodes" />
        <AccesslinkGridView v-if="listViewType === 'grid'" :code="code" :pods="getAccesslinkPods" :nodes="getAccesslinkNodes" />

        <v-row class="mt-4" v-if="downloadingAllowed">
          <v-col offset="0" cols="12"  offset-sm="1" sm="10"  offset-md="2" md="8" class="text-center">
            <v-btn color="primary" variant="flat" @click="downloadAll()" :elevation="0" :aria-label="$t('routes.accesslink.downloadAll')">
              {{ $t('routes.accesslink.downloadAll') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { marked } from 'marked';
import { useAccesslinkStore } from '@/stores/AccesslinkStore';
import AccesslinkTopBar from "./components/AccesslinkTopBar.vue"
import AccesslinkListView from '@/routes/accesslink2/components/list-view/AccesslinkListView.vue';
import AccesslinkGridView from '@/routes/accesslink2/components/grid-view/AccesslinkGridView.vue';
import { useTheme } from 'vuetify';

export default {
  name: "AccessLinkListView",
  components: {
    AccesslinkGridView,
    AccesslinkListView,
    AccesslinkTopBar,
  },
  data() {
    return {
      code: "",
      sidemenuDrawer: null,
    };
  },
  mounted() {
    this.code = this.$route.params.code;
    if (this.getAccesslinkPods.length === 0 && this.getAccesslinkNodes.length === 0) {
      this.$router.replace({ name: 'accesslink:index' });
      return;
    }

    const theme = useTheme();
    if (
      this.getAccesslinkInfo &&
      this.getAccesslinkInfo.brand &&
      this.getAccesslinkInfo.brand.theme &&
      this.getAccesslinkInfo.brand.theme === 'dark'
    ) {
      theme.change('dark');
    } else {
      theme.change('light');
    }
  },
  methods: {
    toggleSidemenu() {
      this.sidemenuDrawer = !this.sidemenuDrawer;
    },
    // downloadAsset: function() {
    //   if (this.pod && this.pod.asset && this.pod.asset.raw && this.pod.asset.raw[0]) {
    //     window.location.href = this.pod.asset.raw[0].url;
    //   }
    // },
    downloadAll: function() {
      if (!this.getAccesslinkInfo || !this.getAccesslinkInfo.code || !this.downloadingAllowed) {
        return;
      }

      const payload = {
        code: this.getAccesslinkInfo.code,
      };

      const accesslinkStore = useAccesslinkStore();
      accesslinkStore.downloadAccesslinkFiles(payload);
    },
    toggleListViewType() {
      const accesslinkStore = useAccesslinkStore();
      accesslinkStore.toggleListViewType();
    },
  },
  computed: {
    getAccesslinkInfo: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getAccesslinkInfo;
    },
    getAccesslinkPods: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getAccesslinkPods;
    },
    getAccesslinkNodes: function () {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getAccesslinkNodes;
    },
    getNotes: function() {
      if (this.getAccesslinkInfo && this.getAccesslinkInfo.note) {
        return marked(this.getAccesslinkInfo.note, { breaks: false });
      }

      return "";
    },
    downloadingAllowed: function() {
      if (this?.getAccesslinkInfo?.params) {
        return this.getAccesslinkInfo.params.allowdownloading === 1;
      }
      return false;
    },
    listViewType: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getListViewType;
    },
  }
}
</script>

<style lang="scss" scoped>
#accesslink-main-container {
  min-height: 100%;
  padding: 16px 12px;
}

.accesslink-notes {
  padding: 20px;
  border-radius: 10px;

  :global(.v-theme--light &) {
    background-color: #FFFFFF;
  }

  :global(.v-theme--dark &) {
    background-color: #232b36;
  }
}
</style>
